import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgIconsModule } from '@ng-icons/core';
import { heroXMark } from '@ng-icons/heroicons/outline';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AlertComponent } from './component/alert/alert.component';
import {
	RtButtonModule,
	RtHeadingModule,
	RtLayoutModule,
	RtLinkModule,
	RtNotificationModule,
} from './component/rt-design-system/src/public-api';
import { SelectCountriesComponent } from './component/select-countries/select-countries.component';
import { SelectStringComponent } from './component/select-string/select-string.component';
import { SelectComponent } from './component/select/select.component';
import { StepperComponent } from './component/stepper/stepper.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { OnlyDigitDirective } from './directives/only-digit.directive';
import { SearchPipe } from './pipes/search.pipe';

@NgModule({
	declarations: [
		SelectCountriesComponent,
		SelectComponent,
		SelectStringComponent,
		StepperComponent,
		ClickOutsideDirective,
		SearchPipe,
		AlertComponent,
		OnlyDigitDirective,
	],
	imports: [
		NgIconsModule.withIcons({ heroXMark }),
		CommonModule,
		TranslateModule,
		NgxSpinnerModule,
		RouterModule,
		RtNotificationModule,
		RtLayoutModule,
		RtLinkModule,
		RtButtonModule,
		RtHeadingModule,
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		SelectCountriesComponent,
		SelectComponent,
		SelectStringComponent,
		StepperComponent,
		NgxChartsModule,
		NgxSpinnerModule,
		ClickOutsideDirective,
		SearchPipe,
		AlertComponent,
		OnlyDigitDirective,
	],
})
export class SharedModule {}
